import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...args) {
  return twMerge(clsx(args));
}

export function Button({ className, variant = "primary", size = "md", ...props }) {
  const base = "inline-flex items-center justify-center rounded-sm font-semibold uppercase tracking-widest transition-colors border";
  const variants = {
    primary: "bg-[hsl(var(--primary))] text-black hover:bg-[hsl(var(--primary))]/85 border-transparent",
    outline: "bg-transparent text-white border-white/15 hover:bg-white/5",
    ghost: "bg-transparent text-white border-transparent hover:bg-white/5",
    danger: "bg-transparent text-red-400 border-red-400/40 hover:bg-red-400/10",
  };
  const sizes = {
    sm: "text-[10px] px-2 py-1.5",
    md: "text-xs px-3 py-2",
    lg: "text-sm px-4 py-2.5",
  };
  return <button className={cn(base, variants[variant], sizes[size], className)} {...props} />;
}

export function Input({ className, ...props }) {
  return (
    <input
      className={cn("w-full bg-panel border border-panel px-3 py-2 rounded-sm text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[hsl(var(--primary))]/60", className)}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }) {
  return (
    <textarea
      className={cn("w-full bg-panel border border-panel px-3 py-2 rounded-sm text-sm text-white placeholder:text-gray-500 focus:outline-none focus:border-[hsl(var(--primary))]/60", className)}
      {...props}
    />
  );
}

export function Select({ className, children, ...props }) {
  return (
    <select className={cn("w-full bg-panel border border-panel px-3 py-2 rounded-sm text-sm text-white focus:outline-none focus:border-[hsl(var(--primary))]/60", className)} {...props}>
      {children}
    </select>
  );
}

export function Label({ className, ...props }) {
  return <label className={cn("block text-[10px] uppercase tracking-widest text-gray-400 mb-1", className)} {...props} />;
}

export function Card({ className, children }) {
  return <div className={cn("bg-panel border border-panel rounded-sm", className)}>{children}</div>;
}

export function CardContent({ className, children }) {
  return <div className={cn("p-6", className)}>{children}</div>;
}

export function Badge({ className, children }) {
  return <span className={cn("inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-widest px-2 py-1 rounded-sm", className)}>{children}</span>;
}

export function Switch({ checked, onChange, className, ...props }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange?.(!checked)}
      className={cn(
        "relative inline-flex h-5 w-9 items-center rounded-full transition-colors",
        checked ? "bg-[hsl(var(--primary))]" : "bg-white/10",
        className
      )}
      {...props}
    >
      <span className={cn("inline-block h-3.5 w-3.5 rounded-full bg-white transition-transform ml-0.5", checked ? "translate-x-4" : "translate-x-0")} />
    </button>
  );
}
